export const STAGE_GET_INIT_DATA = "STAGE_GET_INIT_DATA";
export const SEND_GET_INIT_DATA = "SEND_GET_INIT_DATA";
export const SAVE_INIT_DATA_FLAG = "SAVE_INIT_DATA_FLAG";
export const STAGE_REPORTING_EVENT_INIT_DATA = "STAGE_REPORTING_EVENT_INIT_DATA";
export const SAVE_INIT_DATA = "SAVE_INIT_DATA";
export const SAVE_PRE_AUTH_INIT_DATA = "SAVE_PRE_AUTH_INIT_DATA";
export const SAVE_PRODUCT_PAYLOAD = "SAVE_PRODUCT_PAYLOAD";
export const SET_RESET_FUNCTION_FLAG = "SET_RESET_FUNCTION_FLAG";
export const SET_UDP_VARS = "SET_UDP_VARS";
export const SAVE_USER_ADVOCACY_AVAILABILITY = "SAVE_USER_ADVOCACY_AVAILABILITY";
export const SET_USER_INITIALIZE_COMPLETE = "SET_USER_INITIALIZE_COMPLETE";


// WEBPACK FOOTER //
// ./modules/initialization-data-handler/actions/actionTypes.ts